<template>
  <footer class="app-footer" :class="footerClass">
    <a class="app-footer__support" href="mailto:support@speedyimg.com">support@speedyimg.com</a>
    <div class="app-footer__legal">
      <a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      <span class="app-footer__sep" aria-hidden="true">·</span>
      <a href="/terms-and-conditions.html" target="_blank" rel="noopener noreferrer">Terms and Conditions</a>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  props: {
    variant: {
      type: String,
      default: 'landing',
      validator: (v) => ['landing', 'dashboard'].includes(v),
    },
  },
  computed: {
    footerClass() {
      return this.variant === 'dashboard' ? 'app-footer--dashboard' : 'app-footer--landing';
    },
  },
};
</script>

<style scoped>
.app-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px 20px;
  padding: 16px max(env(safe-area-inset-left), clamp(16px, 4vw, 28px))
    calc(16px + env(safe-area-inset-bottom)) max(env(safe-area-inset-right), clamp(16px, 4vw, 28px));
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  font-size: 13px;
  box-sizing: border-box;
  max-width: 100%;
  justify-content: space-between;
}

.app-footer a {
  color: rgba(247, 247, 251, 0.72);
  text-decoration: none;
  transition: color 0.15s ease, opacity 0.15s ease;
}

.app-footer a:hover {
  color: #f7f7fb;
}

.app-footer__support {
  min-width: 0;
  overflow-wrap: anywhere;
}

.app-footer__legal {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  gap: 8px 10px;
  margin-left: auto;
  min-width: 0;
}

.app-footer__sep {
  color: rgba(247, 247, 251, 0.35);
  user-select: none;
  flex-shrink: 0;
}

@media screen and (max-width: 560px) {
  .app-footer {
    flex-direction: column;
    align-items: stretch;
    text-align: center;
    gap: 14px;
  }

  .app-footer__legal {
    margin-left: 0;
    justify-content: center;
  }
}

.app-footer--dashboard {
  border-top-color: rgba(255, 255, 255, 0.1);
}

.app-footer--dashboard a {
  color: rgba(247, 247, 251, 0.78);
}

.app-footer--dashboard a:hover {
  color: #fff;
}
</style>
